<template>
  <div>
    <base-header class="pb-6" type>
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Course settings')"></breadcrumbs>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <form-edit-course :courseId="$route.params.courseId"></form-edit-course>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "../../Layout/Breadcrumbs";
import FormEditCourse from "../../Forms/Course/FormEditCourse";

export default {
  name: "CourseSettings",
  metaInfo() {
    return {
      title: this.$i18n.t("Settings"),
    };
  },
  components: { FormEditCourse, Breadcrumbs },
};
</script>

<style lang="scss">
  .main-content > div {
    max-width: 1100px;
    margin: auto;
  }
</style>
